import { createTheme } from '@mui/material'

const DEFAULT_MODE = 'light'
export const SELECTED_MODE = localStorage.getItem('theme.mode') ?? DEFAULT_MODE

import LOADED from '@components/Theme'

// TODO: Dynamic theme import
/* const importTheme = async() => {
    const paletteModule = await import(`../components/Theme/Palette/${SELECTED_THEME}_${SELECTED_MODE}`)
    const typographyModule = await import(`../components/Theme/Typography/${SELECTED_THEME}`)
    const themeModule = await import(`../components/Theme/${SELECTED_THEME}`)

    return {
        palette: paletteModule.default,
        typography: typographyModule.default,
        theme: themeModule.default
    }
}

const LOADED = await importTheme() */

export const LOADED_PALETTE = LOADED.palette
export const LOADED_TYPOGRAPHY = LOADED.typography
export const LOADED_THEME = LOADED.theme

const theme = createTheme({
    zIndex: {
        mobileStepper: 1,
        fab: 2,
        speedDial: 2,
        appBar: 3,
        drawer: 4,
        modal: 5,
        snackbar: 6,
        tooltip: 7,
        dpHeader: 10,
        loader: 11,
        max: 9999,
        ...LOADED_THEME?.override?.zIndex
    },
    components: {
        MuiTypography: {
            ...LOADED_THEME?.components?.MuiTypography,
            defaultProps: {
                color: 'body1',
                ...LOADED_THEME?.components?.MuiTypography?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'body1'},
                    style: {
                        color: LOADED_PALETTE?.MuiTypography.body1,
                        ...LOADED_THEME?.components?.MuiTypography?.variant?.body1
                    }
                },
                {
                    props: {variant: 'body2'},
                    style: {
                        color: LOADED_PALETTE?.MuiTypography.body2,
                        ...LOADED_THEME?.components?.MuiTypography?.variant?.body2
                    }
                },
                {
                    props: {variant: 'body3'},
                    style: {
                        color: LOADED_PALETTE?.MuiTypography.secondary,
                        ...LOADED_THEME?.components?.MuiTypography?.variant?.body2
                    }
                },
                {
                    props: {color: 'label'},
                    style: {
                        color: LOADED_PALETTE?.MuiTypography.secondary,
                    }
                },
                ...LOADED_THEME?.components?.MuiTypography?.variants || []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiTypography?.styleOverrides,
                root: {
                    color: LOADED_PALETTE?.MuiTypography.global,
                    ...LOADED_THEME?.components?.MuiTypography?.styleOverrides?.root
                }
            }
        },
        MuiLinearProgress: {
            ...LOADED_THEME?.components?.MuiLinearProgress,
            defaultProps: {
                color: 'primary',
                ...LOADED_THEME?.components?.MuiLinearProgress?.defaultProps
            },
            variants: [
                {
                    props: {color: 'primary'},
                    style: {
                        ['& .MuiLinearProgress-bar']: {
                            backgroundColor: LOADED_PALETTE?.MuiLinearProgress?.primary.background
                        },
                        ...LOADED_THEME?.components?.MuiLinearProgress?.variant?.primary
                    }
                },
                {
                    props: {color: 'secondary'},
                    style: {
                        ['& .MuiLinearProgress-bar']: {
                            backgroundColor: LOADED_PALETTE?.MuiLinearProgress?.secondary.background
                        },
                        ...LOADED_THEME?.components?.MuiLinearProgress?.variant?.secondary,
                    }
                },
                {
                    props: {color: 'success'},
                    style: {
                        ['& .MuiLinearProgress-bar']: {
                            backgroundColor: LOADED_PALETTE?.MuiLinearProgress?.success.background
                        },
                        ...LOADED_THEME?.components?.MuiLinearProgress?.variant?.success
                    }
                },
                {
                    props: {color: 'error'},
                    style: {
                        ['& .MuiLinearProgress-bar']: {
                            backgroundColor: LOADED_PALETTE?.MuiLinearProgress?.error.background
                        },
                        ...LOADED_THEME?.components?.MuiLinearProgress?.variant?.error
                    }
                },
                ...LOADED_THEME?.components?.MuiLinearProgress?.variants || []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiLinearProgress?.styleOverrides,
                root: {
                    borderRadius: '5px',
                    minHeight: '8px',
                    backgroundColor: `${LOADED_PALETTE?.MuiLinearProgress?.background} !important`,
                    ...LOADED_THEME?.components?.MuiLinearProgress?.styleOverrides?.root
                }
            }
        },
        MuiAccordion: {
            ...LOADED_THEME?.components?.MuiAccordion,
            defaultProps: {
                elevation: 0,
                ...LOADED_THEME?.components?.MuiAccordion?.defaultProps
            },
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiAccordion?.styleOverrides,
                root: {
                    marginTop: '10px',
                    [`&:before`]: {
                        backgroundColor: 'unset'
                    },
                    borderRadius: LOADED_THEME.global.radius ?? 'initial',
                    [`&:last-of-type`]: {
                        borderRadius: LOADED_THEME.global.radius ?? 'initial',
                    },
                    [`&:first-of-type`]: {
                        borderRadius: LOADED_THEME.global.radius ?? 'initial',
                    },
                    [`& .MuiAccordionSummary-expandIconWrapper`]: {
                        color: LOADED_PALETTE?.MuiAccordion?.iconWrapper ?? 'initial'
                    },
                    background: LOADED_PALETTE?.MuiAccordion?.background ?? 'initial',
                    border: `1px solid ${LOADED_PALETTE?.MuiAccordion?.border ?? 'initial'}`,
                    ...LOADED_THEME?.components?.MuiAccordion?.styleOverrides?.root
                }
            }
        },
        MuiAccordionSummary: {
            ...LOADED_THEME?.components?.MuiAccordionSummary,
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiAccordionSummary?.styleOverrides,
                root: {
                    background: LOADED_PALETTE?.MuiAccordionSummary?.background ?? 'initial',
                    color: LOADED_PALETTE?.MuiAccordionSummary?.color ?? 'initial',
                    borderRadius: LOADED_THEME.global.radius ?? 'initial',
                    [`&.Mui-expanded`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    ...LOADED_THEME?.components?.MuiAccordionSummary?.styleOverrides?.root
                }
            }
        },
        MuiPickersLayout: {
            ...LOADED_THEME?.components?.MuiPickersLayout,
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiPickersLayout?.styleOverrides,
                root: {
                    background: LOADED_PALETTE?.MuiPickersLayout?.background ?? 'initial',
                    ...LOADED_THEME?.components?.MuiPickersLayout?.styleOverrides?.root
                }
            }
        },
        MuiLink: {
            ...LOADED_THEME?.components?.MuiLink,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiLink?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: `${LOADED_PALETTE?.MuiLink?.primary?.color ?? 'initial'} !important`,
                        borderBottom: `${LOADED_THEME?.components?.MuiLink?.variant?.primary?.defaultBorderBottom}`,
                        background: `${LOADED_PALETTE?.MuiLink?.primary?.background} !important`,
                        [`&:hover`]: {
                            color: `${LOADED_PALETTE?.MuiLink?.primary?.hover ?? 'initial'} !important`,
                            backgroundHover: `${LOADED_PALETTE?.MuiLink?.primary?.backgroundHover} !important`,
                            borderBottom: `${LOADED_THEME?.components?.MuiLink?.variant?.primary?.hoverBorderBottom}`
                        },
                        [`&:visited`]: {
                            color: `${LOADED_PALETTE?.MuiLink?.primary?.color ?? 'initial'} !important`
                        },
                        ['&.Mui-disabled']: {
                            color: `${LOADED_PALETTE?.MuiLink?.primary?.hover ?? 'initial'} !important`,
                            borderBottom: `${LOADED_THEME?.components?.MuiLink?.variant?.primary?.disabledBorderBottom}`,
                            opacity: 0.5
                        }
                    }
                },
                ...LOADED_THEME?.components?.MuiLink?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiLink?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiLink?.styleOverrides?.root
                }
            }
        },
        MuiButton: {
            ...LOADED_THEME?.components?.MuiButton,
            defaultProps: {
                variant: 'primary',
                disableElevation: true,
                ...LOADED_THEME?.components?.MuiButton?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: `${LOADED_PALETTE?.MuiButton?.primary?.color ?? 'initial'} !important`,
                        border: `2px solid ${LOADED_PALETTE?.MuiButton?.primary?.border ?? 'initial'} !important`,
                        background: `${LOADED_PALETTE?.MuiButton?.primary?.background ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.primary?.hoverColor ?? 'initial'} !important`,
                            border: `2px solid ${LOADED_PALETTE?.MuiButton?.primary?.hoverBorder ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.primary?.hover ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.primary
                    }
                },
                {
                    props: {variant: 'company'},
                    style: {
                        color: `${LOADED_PALETTE?.MuiButton?.company?.color ?? 'initial'} !important`,
                        borderColor: `${LOADED_PALETTE?.MuiButton?.company?.border ?? 'initial'} !important`,
                        backgroundColor: `${LOADED_PALETTE?.MuiButton?.company?.background ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.company?.hoverColor ?? 'initial'} !important`,
                            borderColor: `${LOADED_PALETTE?.MuiButton?.company?.hoverBorder ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.company?.hover ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.company
                    }
                },
                {
                    props: {variant: 'secondary'},
                    style: {
                        border: '2px solid !important',
                        color: `${LOADED_PALETTE?.MuiButton?.secondary?.color ?? 'initial'} !important`,
                        borderColor: `${LOADED_PALETTE?.MuiButton?.secondary?.border ?? 'initial'} !important`,
                        background: `${LOADED_PALETTE?.MuiButton?.secondary?.background ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.secondary?.hoverColor ?? 'initial'} !important`,
                            borderColor: `${LOADED_PALETTE?.MuiButton?.secondary?.hoverBorder ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.secondary?.hover ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.secondary
                    }
                },
                {
                    props: {variant: 'tertiary'},
                    style: {
                        color: `${LOADED_PALETTE?.MuiButton?.tertiary?.color ?? 'initial'} !important`,
                        borderColor: `${LOADED_PALETTE?.MuiButton?.tertiary?.border ?? 'initial'} !important`,
                        background: `${LOADED_PALETTE?.MuiButton?.tertiary?.background ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.tertiary?.hoverColor ?? 'initial'} !important`,
                            borderColor: `${LOADED_PALETTE?.MuiButton?.tertiary?.hoverBorder ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.tertiary?.hover ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.tertiary
                    }
                },
                {
                    props: {variant: 'universe'},
                    style: {
                        color: `${LOADED_PALETTE?.MuiButton?.universe?.color ?? 'initial'} !important`,
                        borderColor: `${LOADED_PALETTE?.MuiButton?.universe?.border ?? 'initial'} !important`,
                        background: `${LOADED_PALETTE?.MuiButton?.universe?.background ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.universe?.hoverColor ?? 'initial'} !important`,
                            borderColor: `${LOADED_PALETTE?.MuiButton?.universe?.hoverBorder ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.universe?.hover ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.universe
                    }
                },
                {
                    props: {variant: 'header'},
                    style: {
                        textTransform: 'none',
                        fontWeight: LOADED_THEME.header.fontWeight,
                        fontSize: LOADED_THEME.header.fontSize,
                        minHeight: LOADED_THEME.header.buttonMinHeight,
                        color: `${LOADED_PALETTE?.MuiButton?.header?.color ?? 'initial'} !important`,
                        background: `${LOADED_PALETTE?.MuiButton?.header?.background ?? 'initial'} !important`,
                        borderColor: `${LOADED_PALETTE?.MuiButton?.header?.border ?? 'initial'} !important`,
                        ['&:hover']: {
                            color: `${LOADED_PALETTE?.MuiButton?.header?.colorHover ?? 'initial'} !important`,
                            background: `${LOADED_PALETTE?.MuiButton?.header?.hover ?? 'initial'} !important`
                        },
                        ['& .selected']: {
                            border: 0,
                            borderBottom: `2px solid ${LOADED_PALETTE?.MuiButton?.header?.border}`,
                            color: `${LOADED_PALETTE?.MuiButton?.header?.selectedColor ?? 'initial'} !important`,
                        },
                        ...LOADED_THEME?.components?.MuiButton?.variant?.header
                    }
                },
                ...LOADED_THEME?.components?.MuiButton?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiButton?.styleOverrides,
                root: {
                    height: '32px',
                    borderRadius: '32px',
                    ['&.Mui-disabled']: { opacity: 0.5 },
                    ...LOADED_THEME?.components?.MuiButton?.styleOverrides?.root
                }
            }
        },
        MuiCheckbox: {
            ...LOADED_THEME?.components?.MuiCheckbox,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiCheckbox?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiCheckbox?.primary?.unchecked,
                        ['&.Mui-checked']: {
                            color: LOADED_PALETTE?.MuiCheckbox?.primary?.checked
                        },
                        ['&.MuiCheckbox-indeterminate']: {
                            color: LOADED_PALETTE?.MuiCheckbox?.primary?.indeterminate
                        },
                        ...LOADED_THEME?.components?.MuiCheckbox?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiCheckbox?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiCheckbox?.styleOverrides,
                root: {
                    ['&.Mui-disabled']: { opacity: 0.5 },
                    ...LOADED_THEME?.components?.MuiCheckbox?.styleOverrides?.root
                }
            }
        },
        MuiMenu: {
            ...LOADED_THEME?.components?.MuiMenu,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiMenu?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        ['& .MuiPaper-root']: {
                            background: LOADED_PALETTE?.MuiMenu?.primary?.background,
                        },
                        ...LOADED_THEME?.components?.MuiMenu?.variant?.primary,
                    }
                },
                ...LOADED_THEME?.components?.MuiMenu?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiMenu?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiMenu?.styleOverrides?.root
                }
            }
        },
        MuiMenuItem: {
            ...LOADED_THEME?.components?.MuiMenuItem,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiMenuItem?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiMenuItem?.primary?.color,
                        background: LOADED_PALETTE?.MuiMenuItem?.primary?.background,
                        ['&:hover']: {
                            color: LOADED_PALETTE?.MuiMenuItem?.primary?.hoverColor,
                            background: LOADED_PALETTE?.MuiMenuItem?.primary?.hoverBackground,
                            ['&. MuiIcon-root']: {
                                color: LOADED_PALETTE?.MuiMenuItem?.primary?.iconHoverColor
                            }
                        },
                        ['&.Mui-selected']: {
                            color: LOADED_PALETTE?.MuiMenuItem?.primary?.selectedColor,
                            background: LOADED_PALETTE?.MuiMenuItem?.primary?.selectedBackground
                        },
                        ['&. MuiIcon-root']: {
                            color: LOADED_PALETTE?.MuiMenuItem?.primary?.iconColor
                        },
                        ...LOADED_THEME?.components?.MuiMenuItem?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiMenuItem?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiMenuItem?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiMenuItem?.styleOverrides?.root
                }
            }
        },
        MuiListSubheader: {
            ...LOADED_THEME?.components?.MuiListSubheader,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiListSubheader?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiListSubheader?.primary?.color,
                        background: LOADED_PALETTE?.MuiListSubheader?.primary?.background,
                        ...LOADED_THEME?.components?.MuiListSubheader?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiListSubheader?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiListSubheader?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiListSubheader?.styleOverrides?.root
                }
            }
        },
        MuiTabs: {
            ...LOADED_THEME?.components?.MuiTabs,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiTabs?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiTabs?.primary?.background,
                        border: 0,
                        borderBottom: `1px solid ${LOADED_PALETTE?.MuiTabs?.primary?.border}`,
                        ['& .MuiTabs-indicator']: {
                            backgroundColor: LOADED_PALETTE?.MuiTabs?.primary?.selectedBorder
                        },
                        ['& .MuiButtonBase-root']: {
                            textTransform: 'none'
                        },
                        ...LOADED_THEME?.components?.MuiTabs?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiTabs?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiTabs?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiTabs?.styleOverrides?.root
                }
            }
        },
        MuiTab: {
            ...LOADED_THEME?.components?.MuiTab,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiTab?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiTab?.primary?.background,
                        color: LOADED_PALETTE?.MuiTab?.primary?.color,
                        fontWeight: 400,
                        minHeight: '40px',
                        ['&.Mui-selected']: {
                            fontWeight: 600,
                            background: LOADED_PALETTE?.MuiTab?.primary?.background,
                            color: LOADED_PALETTE?.MuiTab?.primary?.color,
                        },
                        ...LOADED_THEME?.components?.MuiTab?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiTab?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiTab?.styleOverrides,
                root: {
                    ['& .Mui-disabled']: { opacity: 0.5 },
                    ...LOADED_THEME?.components?.MuiTab?.styleOverrides?.root
                }
            }
        },
        MuiSwitch: {
            ...LOADED_THEME?.components?.MuiSwitch,
            defaultProps: {
                color: 'primary',
                ...LOADED_THEME?.components?.MuiSwitch?.defaultProps
            },
            variants: [
                {
                    props: { color: 'primary' },
                    style: {
                        padding: 8,
                        ['& .MuiSwitch-track']: {
                            borderRadius: 22 / 2,
                            opacity: '1 !important',
                            background: `${LOADED_PALETTE?.MuiSwitch?.primary?.background?.unchecked ?? 'initial'} !important`
                        },
                        ['& .Mui-checked+.MuiSwitch-track']: {
                            opacity: '1 !important',
                            background: `${LOADED_PALETTE?.MuiSwitch?.primary?.background?.checked ?? 'initial'} !important`
                        },
                        ['& .MuiSwitch-thumb']: {
                            boxShadow: 'none',
                            width: 16,
                            height: 16,
                            margin: 2,
                            background: `${LOADED_PALETTE?.MuiSwitch?.primary?.thumb?.unchecked ?? 'initial'} !important`
                        },
                        ['& .Mui-checked .MuiSwitch-thumb']: {
                            background: `${LOADED_PALETTE?.MuiSwitch?.primary?.thumb?.checked ?? 'initial'} !important`
                        },
                        ...LOADED_THEME?.components?.MuiSwitch?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiSwitch?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiSwitch?.styleOverrides,
                root: {
                    ['& .Mui-disabled']: { opacity: 0.5 },
                    ...LOADED_THEME?.components?.MuiSwitch?.styleOverrides?.root
                }
            }
        },
        MuiRadio: {
            ...LOADED_THEME?.components?.MuiRadio,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiRadio?.defaultProps
            },
            variants: [
                {
                    props: { variant: 'primary' },
                    style: {
                        color: LOADED_PALETTE?.MuiRadio?.primary?.unchecked,
                        ['&.Mui-checked']: {
                            color: LOADED_PALETTE?.MuiRadio?.primary?.checked
                        },
                        ...LOADED_THEME?.components?.MuiRadio?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiRadio?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiRadio?.styleOverrides,
                root: {
                    ['&.Mui-disabled']: { opacity: 0.5 },
                    ...LOADED_THEME?.components?.MuiRadio?.styleOverrides?.root
                }
            }
        },
        MuiFormControlLabel: {
            ...LOADED_THEME?.components?.MuiFormControlLabel,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiFormControlLabel?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiFormControlLabel?.primary,
                        ...LOADED_THEME?.components?.MuiFormControlLabel?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiFormControlLabel?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiFormControlLabel?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiFormControlLabel?.styleOverrides?.root
                }
            }
        },
        MuiFormLabel: {
            ...LOADED_THEME?.components?.MuiFormLabel,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiFormLabel?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiFormLabel?.primary,
                        fontWeight: '400',
                        fontSize: '12px',
                        ...LOADED_THEME?.components?.MuiFormLabel?.variant?.primary
                    }
                },
                {
                    props: {variant: 'success'},
                    style: {
                        color: LOADED_PALETTE?.MuiFormLabel?.success,
                        fontWeight: '400',
                        fontSize: '12px',
                        ...LOADED_THEME?.components?.MuiFormLabel?.variant?.secondary
                    }
                },
                ...LOADED_THEME?.components?.MuiFormLabel?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiFormLabel?.styleOverrides,
                root: {
                    color: LOADED_PALETTE?.MuiFormLabel?.color,
                    ...LOADED_THEME?.components?.MuiFormLabel?.styleOverrides?.root
                }
            }
        },
        MuiFormHelperText: {
            ...LOADED_THEME?.components?.MuiFormHelperText,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiFormHelperText?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        color: LOADED_PALETTE?.MuiFormHelperText?.primary,
                        ...LOADED_THEME?.components?.MuiFormHelperText?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiFormHelperText?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiFormHelperText?.styleOverrides,
                root: {
                    color: LOADED_PALETTE?.MuiFormHelperText?.color,
                    ...LOADED_THEME?.components?.MuiFormHelperText?.styleOverrides?.root
                }
            }
        },
        MuiPaper:{
            defaultProps: {
                elevation: 0,
                ...LOADED_THEME?.MuiPaper?.defaultProps
            },
            styleOverrides: {
                root: {
                    ...LOADED_THEME?.MuiPaper?.styleOverrides
                }
            },
            ...LOADED_THEME?.MuiPaper
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    ['.MuiListItemText-primary']: {
                        fontSize: '14px'
                    },
                    ...LOADED_THEME?.MuiListItemText?.styleOverrides
                }
            },
            ...LOADED_THEME?.MuiListItemText
        },
        MuiSelect: {
            styleOverrides: {
                ...LOADED_THEME?.MuiSelect?.styleOverrides,
                root: {
                    ['& fieldset']: {
                        borderColor: LOADED_PALETTE.SingleSelect.primary.fieldSet
                    },
                    ['& svg']: {
                        borderColor: LOADED_PALETTE.SingleSelect.primary.expander
                    },
                    ['&:hover']: {
                        ['& fieldset']: {
                            borderColor: `${LOADED_PALETTE.SingleSelect.primary.fieldSetHover} !important`
                        }
                    },
                    background: LOADED_PALETTE.SingleSelect.primary.background,
                    color: LOADED_PALETTE.SingleSelect.primary.color,
                    ...LOADED_THEME?.MuiSelect?.styleOverrides?.root
                }
            },
            ...LOADED_THEME?.MuiSelect
        },
        MuiIcon: {
            ...LOADED_THEME?.MuiIcon,
            defaultProps: {
                baseClassName: 'material-symbols-rounded',
                ...LOADED_THEME?.MuiIcon?.defaultProps
            },
            styleOverrides: {
                root: {
                    ['&.MuiIcon-colorPrimary']: {
                        color: `${LOADED_PALETTE.icon.primary ?? 'initial'}`
                    },
                    ['&.MuiIcon-colorSecondary']: {
                        color: `${LOADED_PALETTE.icon.secondary ?? 'initial'}`
                    },
                    ...LOADED_THEME?.MuiIcon?.styleOverrides
                }
            }
        },
        MuiDialog: {
            ...LOADED_THEME?.components?.MuiDialog,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiDialog?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiDialog?.primary?.wrapper,
                        ['& .MuiDialog-paper']: {
                            background: LOADED_PALETTE?.MuiDialog?.primary?.background
                        },
                        ...LOADED_THEME?.components?.MuiDialog?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiDialog?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiDialog?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiDialog?.styleOverrides?.root
                }
            }
        },
        MuiDialogTitle: {
            ...LOADED_THEME?.components?.MuiDialogTitle,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiDialogTitle?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiDialogTitle?.primary?.background,
                        ...LOADED_THEME?.components?.MuiDialogTitle?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiDialogTitle?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiDialogTitle?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiDialogTitle?.styleOverrides?.root
                }
            }
        },
        MuiDialogContent: {
            ...LOADED_THEME?.components?.MuiDialogContent,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiDialogContent?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiDialogContent?.primary?.background,
                        ...LOADED_THEME?.components?.MuiDialogContent?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiDialogContent?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiDialogContent?.styleOverrides,
                root: {
                    ...LOADED_THEME?.components?.MuiDialogContent?.styleOverrides?.root
                }
            }
        },
        MuiDialogActions: {
            ...LOADED_THEME?.components?.MuiDialogActions,
            defaultProps: {
                variant: 'primary',
                ...LOADED_THEME?.components?.MuiDialogActions?.defaultProps
            },
            variants: [
                {
                    props: {variant: 'primary'},
                    style: {
                        background: LOADED_PALETTE?.MuiDialogActions?.primary?.background,
                        ...LOADED_THEME?.components?.MuiDialogActions?.variant?.primary
                    }
                },
                ...LOADED_THEME?.components?.MuiDialogActions?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiDialogActions?.styleOverrides,
                root: {
                    padding: '16px 24px',
                    ...LOADED_THEME?.components?.MuiDialogActions?.styleOverrides?.root
                }
            }
        },
        MuiChip: {
            ...LOADED_THEME?.components?.MuiChip,
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiChip?.styleOverrides,
                root: {
                    height: '24px',
                    border: '1px solid',
                    fontSize: '12px',
                    fontWeight: 500,
                    ...LOADED_THEME?.components?.MuiChip?.styleOverrides?.root
                }
            }
        },
        MuiAlert: {
            ...LOADED_THEME?.components?.MuiAlert,
            defaultProps: {
                severity: 'info',
                ...LOADED_THEME?.components?.MuiAlert?.defaultProps
            },
            variants: [
                {
                    props: {severity: 'info'},
                    style: {
                        background: LOADED_PALETTE?.MuiAlert?.info?.background,
                        borderColor: LOADED_PALETTE?.MuiAlert?.info?.border,
                        ['& .MuiTypography-h6']: {
                            color: LOADED_PALETTE?.MuiAlert?.info?.color,
                        },
                        ['& .MuiTypography-body2']: {
                            color: LOADED_PALETTE?.MuiAlert?.info?.color
                        },
                        ['& .close-icon']: {
                            color: LOADED_PALETTE?.MuiAlert?.info?.color
                        },
                        ...LOADED_THEME?.components?.MuiAlert?.variant?.info
                    }
                },
                {
                    props: {severity: 'success'},
                    style: {
                        background: LOADED_PALETTE?.MuiAlert?.success?.background,
                        borderColor: LOADED_PALETTE?.MuiAlert?.success?.border,
                        ['& .MuiTypography-h6']: {
                            color: LOADED_PALETTE?.MuiAlert?.success?.color
                        },
                        ['& .MuiTypography-body2']: {
                            color: LOADED_PALETTE?.MuiAlert?.success?.color
                        },
                        ['& .close-icon']: {
                            color: LOADED_PALETTE?.MuiAlert?.success?.color
                        },
                        ...LOADED_THEME?.components?.MuiAlert?.variant?.success
                    }
                },
                {
                    props: {severity: 'warning'},
                    style: {
                        background: LOADED_PALETTE?.MuiAlert?.warning?.background,
                        borderColor: LOADED_PALETTE?.MuiAlert?.warning?.border,
                        ['& .MuiTypography-h6']: {
                            color: LOADED_PALETTE?.MuiAlert?.warning?.color
                        },
                        ['& .MuiTypography-body2']: {
                            color: LOADED_PALETTE?.MuiAlert?.warning?.color
                        },
                        ['& .close-icon']: {
                            color: LOADED_PALETTE?.MuiAlert?.warning?.color
                        },
                        ...LOADED_THEME?.components?.MuiAlert?.variant?.warning
                    }
                },
                {
                    props: {severity: 'error'},
                    style: {
                        background: LOADED_PALETTE?.MuiAlert?.error?.background,
                        borderColor: LOADED_PALETTE?.MuiAlert?.error?.border,
                        ['& .MuiTypography-h6']: {
                            color: LOADED_PALETTE?.MuiAlert?.error?.color
                        },
                        ['& .MuiTypography-body2']: {
                            color: LOADED_PALETTE?.MuiAlert?.error?.color
                        },
                        ['& .close-icon']: {
                            color: LOADED_PALETTE?.MuiAlert?.error?.color
                        },
                        ...LOADED_THEME?.components?.MuiAlert?.variant?.error
                    }
                },
                ...LOADED_THEME?.components?.MuiAlert?.variants ?? []
            ],
            styleOverrides: {
                ...LOADED_THEME?.components?.MuiAlert?.styleOverrides,
                root: {
                    border: '1px solid',
                    ...LOADED_THEME?.components?.MuiAlert?.styleOverrides?.root
                }
            }
        },
        Textinput: {
            ...LOADED_THEME?.Textinput,
            Search: {
                ...LOADED_THEME?.search
            },
            variants: {
                ...LOADED_THEME?.Textinput?.variants,
                primary: {
                    background: `${LOADED_PALETTE?.Textinput?.primary?.background ?? 'initial'}`,
                    ['& .MuiInputBase-formControl']: {
                        height: '40px'
                    },
                    ['& input']: {
                        fontWeight: 400,
                        fontSize: 14,
                        color: `${LOADED_PALETTE?.Textinput?.primary?.color ?? 'initial'}`
                    },
                    ['& fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.primary?.fieldSet ?? 'initial'}`
                    },
                    ['&.inputSuccess fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.primary?.fieldSetSuccess ?? 'initial'} !important`
                    },
                    ['& .MuiInputBase-input:hover + fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.primary?.fieldSetHover ?? 'initial'}`
                    },
                    ...LOADED_THEME?.Textinput?.variants?.primary
                },
                secondary: {
                    background: `${LOADED_PALETTE?.Textinput?.secondary?.background ?? 'initial'}`,
                    ['& .MuiInputBase-formControl']: {
                        height: '40px'
                    },
                    ['& input']: {
                        fontWeight: 400,
                        fontSize: 14,
                        color: `${LOADED_PALETTE?.Textinput?.secondary?.color ?? 'initial'}`
                    },
                    ['& fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.secondary?.fieldSet ?? 'initial'}`
                    },
                    ['&.inputSuccess fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.secondary?.fieldSetSuccess ?? 'initial'} !important`
                    },
                    ['& .MuiInputBase-input:hover + fieldset']: {
                        border: `1px solid ${LOADED_PALETTE?.Textinput?.secondary?.fieldSetHover ?? 'initial'}`
                    },
                    ...LOADED_THEME?.Textinput?.variants?.secondary
                }
            }
        },
        Tile: {
            ...LOADED_THEME?.Tile,
            variants: {
                ...LOADED_THEME?.Tile?.variants,
                primary: {
                    borderRadius: LOADED_THEME.global.radius,
                    padding: '16px',
                    border: `1px solid ${LOADED_PALETTE.Tile.primary.border}`,
                    background: LOADED_PALETTE.Tile.primary.background,
                    color: LOADED_PALETTE.Tile.primary.color.main,
                    [`&.Tile-checked`]: {
                        border: `2px solid ${LOADED_PALETTE.Tile.primary.checked}`,
                    },
                    [`& .Tile-label`]: {
                        fontWeight: 600,
                        fontSize: 20,
                        lineHeight: '28px',
                        color: LOADED_PALETTE.Tile.primary.color.label,
                        [`&:hover`]: {
                            color: LOADED_PALETTE.Tile.primary.color.hoverLabel
                        }
                    },
                    [`& .Tile-sublabel`]: {
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '20px',
                        color: LOADED_PALETTE.Tile.primary.color.sublabel
                    },
                    [`& .Tile-children`]: {
                        marginTop: 2
                    },
                    [`& .Tile-children-noMargin`]: {
                        marginTop: 0
                    },
                    [`&.Tile-clickable&:hover`]: {
                        cursor: 'pointer',
                        background: LOADED_PALETTE.Tile.primary.hover,
                        [`& .Tile-label`]: {
                            color: LOADED_PALETTE.Tile.primary.color.hoverLabel
                        },
                        [`& .Tile-sublabel`]: {
                            color: LOADED_PALETTE.Tile.primary.color.hoverSublabel
                        }
                    },
                    ...LOADED_THEME?.components?.Tile?.variant?.primary
                }
            }
        },
        ...LOADED_THEME?.overrides?.components
    },
    typography: LOADED_TYPOGRAPHY,
    palette: {
        ...LOADED_PALETTE,
        mode: SELECTED_MODE,
        accent: {
            success: LOADED_PALETTE.accent.success,
            alert: LOADED_PALETTE.accent.alert,
            warning: LOADED_PALETTE.accent.warning,
            info: LOADED_PALETTE.accent.info
        },
        icon: {
            primary: LOADED_PALETTE.icon.primary,
            secondary: LOADED_PALETTE.icon.secondary,
            tertiary: LOADED_PALETTE.icon.tertiary,
            interactive: LOADED_PALETTE.icon.interactive,
            disabled: LOADED_PALETTE.icon.disabled,
            contrasted: {
                primary: LOADED_PALETTE.icon.contrasted.primary,
                disabled: LOADED_PALETTE.icon.contrasted.disabled
            }
        },
        border: {
            subtle: {
                main: LOADED_PALETTE.border.subtle.main,
                alt: LOADED_PALETTE.border.subtle.alt
            },
            strong: {
                main: LOADED_PALETTE.border.strong.main,
                alt: LOADED_PALETTE.border.strong.alt
            },
            interactive: LOADED_PALETTE.border.interactive,
            disabled: LOADED_PALETTE.border.disabled
        },
        data: LOADED_PALETTE.data,
        text: {
            primary: LOADED_PALETTE.text.primary,
            secondary: LOADED_PALETTE.text.secondary,
            placeholder: LOADED_PALETTE.text.placeholder,
            error: LOADED_PALETTE.text.error,
            disabled: LOADED_PALETTE.text.disabled,
            legend: LOADED_PALETTE.text.legend,
            contrasted: {
                primary: LOADED_PALETTE.text.contrasted.primary,
                disabled: LOADED_PALETTE.text.contrasted.disabled
            }
        },
        loader: {
            main: LOADED_PALETTE.loader.main,
            color: LOADED_PALETTE.loader.color
        },
        background: {
            paper: LOADED_PALETTE.background.layer.main.main,
            default: LOADED_PALETTE.background.main,
            transparent: 'transparent',
            body: LOADED_PALETTE.background.body,
            main: LOADED_PALETTE.background.main,
            boxShadow: LOADED_PALETTE.background.boxShadow,
            layer: {
                main: {
                    main: LOADED_PALETTE.background.layer.main.main,
                    hover: LOADED_PALETTE.background.layer.main.hover,
                    active: LOADED_PALETTE.background.layer.main.active
                },
                alt: {
                    main: LOADED_PALETTE.background.layer.alt.main,
                    hover: LOADED_PALETTE.background.layer.alt.hover,
                    active: LOADED_PALETTE.background.layer.alt.active
                }
            },
            success: LOADED_PALETTE.background.success,
            alert: LOADED_PALETTE.background.alert,
            warning: LOADED_PALETTE.background.warning,
            info: LOADED_PALETTE.background.info
        },
        divider: LOADED_PALETTE.border.subtle.main,
        overlay: LOADED_PALETTE.overlay,
        grey: {
            100: LOADED_PALETTE.grey[100],
            200: LOADED_PALETTE.grey[200],
            300: LOADED_PALETTE.grey[300],
            400: LOADED_PALETTE.grey[400],
            500: LOADED_PALETTE.grey[500],
            600: LOADED_PALETTE.grey[600],
            700: LOADED_PALETTE.grey[700],
            800: LOADED_PALETTE.grey[800],
            900: LOADED_PALETTE.grey[900],
        },
        primary: {
            main: LOADED_PALETTE.MuiButton.primary.background
        },
        secondary: {
            main: LOADED_PALETTE.MuiButton.secondary.background
        },
        error: {
            main: LOADED_PALETTE.accent.alert,
            light: LOADED_PALETTE.background.alert,
        },
        warning: {
            main: LOADED_PALETTE.accent.warning,
            light: LOADED_PALETTE.background.warning
        },
        info: {
            main: LOADED_PALETTE.accent.info,
            light: LOADED_PALETTE.background.info
        },
        success: {
            main: LOADED_PALETTE.accent.success,
            light: LOADED_PALETTE.background.success
        },
        ...LOADED_PALETTE?.custom
    }
})

export const transitionIn = {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen
}

export const transitionOut = {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
}

export const zeroBorder = {
    border: 0,
    borderRadius: 0
}

export const DISABLED_OPACITY = LOADED_THEME.global.disabledOpacity

export const ACCENT_BORDER = `3px solid ${theme.palette.primary.main}`

export const DRAWER_WIDTH = LOADED_THEME.global.drawerWidth
export const RADIUS = LOADED_THEME.global.radius

export const MENU_PADDING_RIGHT = LOADED_THEME.global.menuPaddingRight
export const MENU_MARGIN_LEFT = LOADED_THEME.global.menuMarginLeft

export const HEADER_HEIGHT = LOADED_THEME.header.height
export const HEADER_WIDTH = LOADED_THEME.header.width
export const HEADER_POSITION = LOADED_THEME.header.position

export const DISABLED = 'disabled'
export const SELECTED = 'selected'
export const DEFAULT = 'default'

export default theme